<template>
  <div>
    <b-row>
      <b-col sm="12">
        <CheckboxServer title="Colaboradores" :showSearch="true"
          url="/api/v1/human-resources/collaborator/select-all" v-model="collaboratorIds" />
      </b-col>
    </b-row>
    <div v-if="collaboratorIds.length > 0">
      <TeamPeriodValue :team="team" :formName="formName" />
      <b-row>
        <b-col sm="12">
          <EditorHtml title="Descrição" :required="false" :maxLength="1000" v-model="team.description" />
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col sm="12">
          <div class="text-right">
            <Button _key="btnSaveTeamCreate" type="success" title="Salvar"
              :disabled="!isFormValid(formName) || collaboratorIds.length === 0"
              classIcon="fas fa-save" size="medium" :clicked="save" />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import CheckboxServer from "@/ui/forms/CheckboxServer";
import EditorHtml from "@/ui/forms/EditorHtml";
import Button from "@/ui/forms/Button";

import TeamPeriodValue from "./TeamPeriodValue.vue";

import Team from "../models/Team.js";
import TeamService from "../services/team.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TeamCreate",
  components: { CheckboxServer, EditorHtml, Button, TeamPeriodValue },
  props: {
    cardId: {
      type: String,
      default: "",
    },
    rentId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formName: "teamCreate",
      collaboratorIds: [],
      team: new Team(),
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    genericId() {
      return this.cardId || this.rentId;
    },
  },
  methods: {
    ...mapMutations("generic", ["removeLoading", "addEvent"]),
    async save() {
      const payload = {
        genericId: this.genericId,
        collaboratorIds: this.collaboratorIds,
        dateStart: this.team.dateStart,
        timeStart: this.team.timeStart,
        dateEnd: this.team.dateEnd,
        timeEnd: this.team.timeEnd,
        description: this.team.description,
        dueDate: this.team.dueDate,
        value: this.team.value,
      };
      try {
        await TeamService.saveBatch(payload);
        this.addEvent({ name: "reloadCardTeam" });
      } finally {
        this.removeLoading(["btnSaveTeamCreate"]);
      }
    },
  },
  watch: {
    collaboratorIds(value) {
      this.team.collaborator = { id: value[0] || "", content: "" };
    },
  },
};
</script>
<style scoped></style>
